import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { NgClass } from '@angular/common';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ElementTypes, GaContext } from '@fcom/common/interfaces/gtm.interface';
import { DirectiveModule } from '@fcom/common/directives/directive.module';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { UiTranslateModule } from '@fcom/ui-translate/ui-translate.module';

import { IconComponent } from '../../icons/icon/icon.component';
import { TagComponent } from '../../tag/tag.component';
import { TagTheme } from '../../tag/interfaces';

@Component({
  selector: 'fcom-sidebar-item',
  styleUrls: ['./sidebar-item.component.scss'],
  templateUrl: './sidebar-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DirectiveModule, GtmModule, NgClass, IconComponent, TagComponent, UiTranslateModule],
})
export class SidebarItemComponent {
  readonly ElementTypes = ElementTypes;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TRACKING_CONTEXT = GaContext.SECTION_NAVIGATION;
  readonly TagTheme = TagTheme;

  title = input<string>();
  link = input<string>('');
  external = input<boolean>(false);
  openInNewTab = input<boolean>(false);
  active = input<boolean>(false);
  loginRequired = input<boolean>(false);
  styleClasses = input<string>('nordic-blue-900-text text-icon-primary');
  tracking = input<boolean>(false);
  trackingLabel = input<string | undefined>(undefined);
  badge = input<string | undefined>(undefined);

  trackingObj = computed(() => {
    if (!this.tracking()) {
      return null;
    }

    return {
      tracker: `${this.trackingLabel()}${this.link()}`,
      context: this.TRACKING_CONTEXT,
      type: this.ElementTypes.LINK,
    };
  });

  linkClicked = output<Event>();

  onLinkClick(clickEvent: Event): void {
    clickEvent.stopPropagation();
    this.linkClicked.emit(clickEvent);
  }
}
